var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.139,
    height: 21.761,
    viewBox: "0 0 18.139 21.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee7f00;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pdf_download",
    "data-name": "Pdf download",
    transform: "translate(-2036.445 -1624.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pdf-file",
    transform: "translate(2036.445 1624.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    className: "cls-1",
    d: "M119.58,297.982c0-.357-.248-.57-.685-.57a1.513,1.513,0,0,0-.363.034v1.145a1.373,1.373,0,0,0,.294.023C119.293,298.614,119.58,298.379,119.58,297.982Z",
    transform: "translate(-115.118 -283.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    className: "cls-1",
    d: "M194.2,297.681a1.813,1.813,0,0,0-.4.034v2.537a1.583,1.583,0,0,0,.3.018,1.2,1.2,0,0,0,1.312-1.357A1.112,1.112,0,0,0,194.2,297.681Z",
    transform: "translate(-186.894 -284.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    className: "cls-1",
    d: "M57.313,0H48.365a2.348,2.348,0,0,0-2.371,2.316V10.88h-.232a.944.944,0,0,0-.956.933v5.66a.944.944,0,0,0,.956.933h.232v1.038a2.347,2.347,0,0,0,2.371,2.316h12.21a2.347,2.347,0,0,0,2.371-2.316V5.481Zm-10,12.835a7.666,7.666,0,0,1,1.228-.081,1.961,1.961,0,0,1,1.228.314,1.137,1.137,0,0,1,.429.908,1.239,1.239,0,0,1-.37.932,1.893,1.893,0,0,1-1.306.413,2.41,2.41,0,0,1-.31-.017v1.4h-.9Zm13.262,7.507H48.365a.909.909,0,0,1-.918-.9V18.407H58.828a.944.944,0,0,0,.956-.933v-5.66a.944.944,0,0,0-.956-.933H47.446V2.316a.909.909,0,0,1,.918-.9l8.405-.009V4.446a1.626,1.626,0,0,0,1.645,1.606l3.044-.009.034,13.4A.909.909,0,0,1,60.575,20.342Zm-9.8-3.652V12.835a8.377,8.377,0,0,1,1.228-.081,2.634,2.634,0,0,1,1.646.419,1.721,1.721,0,0,1,.679,1.48,1.968,1.968,0,0,1-.668,1.59,2.934,2.934,0,0,1-1.854.506A8.053,8.053,0,0,1,50.779,16.69Zm6.508-2.283v.722H55.844v1.578h-.912V12.783h2.457v.728H55.844v.9Z",
    transform: "translate(-44.806)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownload);
export default __webpack_public_path__ + "static/media/pdfDownload.ea4849b548c19dcb815ae34a128a2a39.svg";
export { ForwardRef as ReactComponent };